var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Default","code-toggler":""}},[_c('p',[_vm._v(" Use the "),_c('code',[_vm._v("items")]),_vm._v(" in order to programatically generate the breadcrumb links ")]),_c('div',{staticClass:"demo-alignment"},[_c('vs-breadcrumb',{attrs:{"items":[
        { title: 'Dashboard', url: '/' },
        { title: 'Link 1', url: '/blog' },
        { title: 'Link 2', disabled: true },
        { title: 'Active', active: true },
      ]}})],1),_c('template',{slot:"codeContainer"},[_vm._v(" <vs-breadcrumb :items=\" [ { title: 'Dashboard', url: '/' }, { title: 'Link 1', url: '/blog' }, { title: 'Link 2', disabled: true }, { title: 'Active', active: true } ]\" ></vs-breadcrumb> ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }